/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {getDisplayCssVars} from '@wix/wixstores-client-storefront-common';
import {getInfoSectionLayoutCustomCssVars} from '../../../productPage/components/InfoSectionLayout/infoSectionLayout.cssVars';
import {getResponsiveLayoutCustomCssVars} from '../../../productPage/components/Layouts/ResponsiveLayout/ResponsiveLayout.cssVars';
import {getOptionsButtonsCustomCssVars} from '../../../productPage/components/ProductOptions/OptionsButton/OptionsButtons.cssVars';
import {getProductOptionsCustomCssVars} from '../../../productPage/components/ProductOptions/ProductOptions.cssVars';
import {getProductPageButtonContainerCustomCssVars} from '../../../productPage/components/ProductPageButtonsContainer/ProductPageButtonContainer.cssVars';
import {getShouldRenderVars} from './shouldRenderVars';
import {getGridGalleryCustomCssVars} from '../../../productPage/components/Layouts/ResponsiveLayout/GridGallery/GridGallery.cssVars';

export const getCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {isRTL} = customCssVarsFnParams;

  return {
    imageGalleryPaginationDotsDirection: isRTL ? 'row-reverse' : 'row',
    ...getProductOptionsCustomCssVars(customCssVarsFnParams),
    ...getProductPageButtonContainerCustomCssVars(customCssVarsFnParams),
    ...getInfoSectionLayoutCustomCssVars(customCssVarsFnParams),
    ...getResponsiveLayoutCustomCssVars(customCssVarsFnParams),
    ...getOptionsButtonsCustomCssVars(customCssVarsFnParams),
    ...getGridGalleryCustomCssVars(customCssVarsFnParams),
  };
};

export const customCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams, isMobile, isRTL} = customCssVarsFnParams;
  const shouldRenderVars = getShouldRenderVars({
    booleans: styleParams.booleans,
    numbers: styleParams.numbers,
    isMobile,
    isRTL,
  });

  return {
    ...getDisplayCssVars({...styleParams.booleans, ...shouldRenderVars}),
    ...getCustomCssVars(customCssVarsFnParams),
  };
};
